import { openBlock as h, createElementBlock as a, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e("path", { d: "M1 1.72A.72.72 0 0 1 1.72 1h3.59a.72.72 0 0 1 0 1.441H2.44V5.31a.72.72 0 1 1-1.441 0V1.72ZM14.28 1a.72.72 0 0 1 .72.72v3.59a.72.72 0 0 1-1.441 0V2.44H10.69a.72.72 0 1 1 0-1.441h3.588ZM2.618 7.28a.72.72 0 1 0 0 1.44h10.764a.72.72 0 0 0 0-1.44H2.618ZM1.72 9.97a.72.72 0 0 1 .721.721v2.868H5.31a.72.72 0 0 1 0 1.441H1.72a.72.72 0 0 1-.72-.72v-3.59a.72.72 0 0 1 .72-.72Zm13.28.721a.72.72 0 0 0-1.441 0v2.868H10.69a.72.72 0 0 0 0 1.441h3.588a.72.72 0 0 0 .721-.72v-3.59Z" }, null, -1), n = /* @__PURE__ */ e("path", { d: "M9.794 4.412h2.691v1.794H9.794V4.412Zm-.897 0H7.103v1.794h1.794V4.412Zm-5.382 0h.897v1.794h-.897V4.412Zm2.691 0h-.897v1.794h.897V4.412Zm3.588 5.382h2.691v1.794H9.794V9.794Zm-5.382 0h-.897v1.794h.897V9.794Zm2.691 0h1.794v1.794H7.103V9.794Zm-.897 0h-.897v1.794h.897V9.794Z" }, null, -1), v = [
  o,
  n
];
function c(m, r) {
  return h(), a("svg", t, [...v]);
}
const Z = { render: c };
export {
  Z as default,
  c as render
};
